import styled from "styled-components";
import { ReactComponent as Logo } from "../../assets/icons/logo.svg";
import { ReactComponent as Phone } from "../../assets/icons/phone.svg";
import { ReactComponent as User } from "../../assets/icons/user.svg";
import { ReactComponent as Plus } from "../../assets/icons/plus.svg";
import { NavLink } from "react-router-dom";

import background from "../../assets/imgs/landing.jpg";

export const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 225px 0 225px;
  background-color: #7a8691;
  background-image: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
    url(${background});
  background-repeat: no-repeat;
  background-size: cover;
`;
Wrap.NavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #fff;
`;
Wrap.Phone = styled(Phone)`
  width: 16px;
  height: 16px;
  path {
    fill: #fff;
  }
  margin-right: 10px;
`;
Wrap.User = styled(User)`
  width: 16px;
  height: 16px;
  path {
    fill: #fff;
  }
  margin-right: 10px;
`;
Wrap.Plus = styled(Plus)`
  width: 16px;
  height: 16px;
  margin-right: 10px;
`;
Wrap.Logo = styled(Logo)`
  width: 40px;
  height: 48px;
  path {
    fill: #fff;
  }
`;
Wrap.LogoWrap = styled.div`
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: bold;
  font-size: 25px;
  line-height: 32px;
  color: #fff;
  span {
    margin-left: 13px;
  }
`;

Wrap.Ul = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
`;

Wrap.Li = styled.li`
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  color: #fff;
  padding-right: 40px;
`;
